import { combineReducers } from 'redux';

import commonReducer from 'modules/common/reducer';
import generalReducer from 'modules/general/reducer';
import accountManagementReducer from 'modules/accountManagement/reducer';
import membersReducer from 'modules/members/reducer';

export default combineReducers({
  common: commonReducer,
  general: generalReducer,
  accountManagement: accountManagementReducer,
  members: membersReducer,
});
